import { defineStore } from 'pinia'

export const useHomeStore = defineStore('home', () => {
    const state = reactive({
        type: 'big',
    })

    return {
        state,
    }
})
